import styled from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const TootipElement = styled.div`
  &&& {
    display: flex;
    gap: ${pxToRem(8)};
    padding-bottom: ${pxToRem(8)};
  }
`;
